/* eslint-disable max-len */
import React from "react"
import styled from "styled-components"
import BaseSvgIcon from "./Base"

const DoctorCareAnywhere = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 55.1 55.4" {...props}>
      <path
        fill="#0050FF"
        fillRule="evenodd"
        d="M45.3,15.9c-2.3,0-4.6,0.9-6.2,2.5c-0.8,0.8-2.4,2.5-2.1,4.1c0.5,3.1-1.5,5.7-1.9,6.8
        c-0.4,1,0.8,0.9,1.7,1.2c-0.1,0.9,0,1.8,0.4,2.6c0.3,0.6,0.3,0.9,0.1,2c-0.1,0.8,0.3,1.6,1,2.1c1.1,0.8,2.5,1.3,3.9,1.3
        c0.3,0,2.1,0.2,2.5,0.2c0,0,0.6,0.1,0.6,0.2v2.3c-8.9,0-13.7-6.2-13.7-13.9s4.8-13.9,13.7-13.9L45.3,15.9L45.3,15.9z M11.4,41.2
        V39c0-0.1,0-0.1,0.1-0.2c0.4,0,1.7-0.2,2-0.2c1.4,0,2.8-0.4,3.9-1.3c0.6-0.5,1-1.3,1-2.1c-0.3-0.6-0.2-1.4,0.1-2
        c0.4-0.8,0.5-1.7,0.4-2.6c0.8-0.3,2.1-0.2,1.7-1.2c-0.3-1.2-2.2-3.7-1.8-6.8c0-1.6-0.6-3.1-1.8-4.1c-1.5-1.5-3.6-2.4-5.7-2.5v-2.5
        c7.7,0,13.9,6.2,13.9,13.8C25.2,34.9,19,41.2,11.4,41.2L11.4,41.2L11.4,41.2z M27.8,2.1C13.8,2,2.5,13.2,2.4,27.1
        c-0.1,13.9,11.1,25.3,25,25.4s25.3-11.1,25.4-25c0-0.1,0-0.1,0-0.2C52.8,13.5,41.6,2.2,27.8,2.1z"
      />
    </BaseSvgIcon>
  )
}

export default styled(DoctorCareAnywhere)``
